<template>
  <v-container v-if="!isPartner">
    <h1>Nos Partenaires</h1>
    <br/>
    <v-row>
      <v-col class="partners" md="4" v-for="(partner, i) in partners" :key="i">
        <a :href="partner.url" target="_blank">
          <v-img class="imgPartner" :src="partner.img" contain />
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  computed: {
    ...mapGetters('app', ['isPartner']),
    ...mapGetters('strapi', ['partners']),
  },
  methods: {
    ...mapActions('strapi', ['getPartner']),
  },
  async mounted () {
    await this.getPartner()
  }
}
</script>

<style scoped>
.partners {
  margin-bottom: 20px;
}
.imgPartner {
  margin: auto;
  width: 220px;
  height: 90px;
}
</style>